/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CustomOption/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CustomOption({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/Filters/ProvidersAndAssistants/Content/Content/CustomOption"
  
}) {
let itemEmployeeResourceEmploymentContractPersonValueData = fromData.useDataFormat({ viewPath,
context: 'item',
path: 'employee_resource.employment_contract.person',
format: fromFormat.personName,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let itemResourceTypeValueData = fromData.useDataFormat({ viewPath,
context: 'item',
path: 'resource_type',
format: fromHelpers.getRole,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="CustomOption.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 data="item.employee_resource.employment_contract.person"
 format="/Data/format.js personName"
 text={itemEmployeeResourceEmploymentContractPersonValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft="auto"
 color={dtColorsNeutral500}
 data="item.resource_type"
 format="helpers.js getRole"
 text={itemResourceTypeValueData}
/>
</div>
{children}
</React.Fragment>)
}